/* La Milpa de María · comportamiento de las secciones lm-*
   Fuente de verdad: theme-src/assets/lm.js. Se re-inicializa cuando el
   editor de temas recarga una sección (shopify:section:load). */
(function () {
  'use strict';

  // carruseles: flechas + barra de progreso
  function initRail(rail) {
    if (rail.dataset.lmReady) return;
    rail.dataset.lmReady = '1';
    var track = rail.querySelector('.lm-track');
    var nav = rail.querySelector('.lm-railnav');
    var bar = rail.querySelector('.lm-progress span');
    if (!track) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 1 : 300; }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var vis = track.clientWidth / track.scrollWidth;
      if (nav) nav.hidden = max <= 2;
      if (!bar) return;
      bar.style.width = (Math.min(1, vis) * 100) + '%';
      bar.style.left = (max > 0 ? (track.scrollLeft / max) * (1 - vis) * 100 : 0) + '%';
    }
    var prev = rail.querySelector('[data-prev]');
    var next = rail.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  // pestañas por necesidad / por categoría (cada sección tiene las suyas)
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-tab]');
    tabs.forEach(function (tab) {
      if (tab.dataset.lmReady) return;
      tab.dataset.lmReady = '1';
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  }

  // marquesina: pausar
  function initMarquee(m) {
    var b = m.querySelector('[data-pause]');
    if (!b || b.dataset.lmReady) return;
    b.dataset.lmReady = '1';
    b.addEventListener('click', function () {
      var p = m.classList.toggle('is-paused');
      b.textContent = p ? b.dataset.resume : b.dataset.pauseLabel;
    });
  }

  // botón "+" de la tarjeta: agrega al carrito igual que el formulario de
  // producto de Savor (mismo evento cart:update), así el ícono del carrito
  // se actualiza y el cajón se abre sin recargar la página.
  function initAdd(form) {
    if (form.dataset.lmReady) return;
    form.dataset.lmReady = '1';
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('.lm-add');
      var err = form.querySelector('.lm-adderr');
      var data = new FormData(form);
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) {
        if (c.dataset.sectionId) ids.push(c.dataset.sectionId);
      });
      if (ids.length) data.append('sections', ids.join(','));
      btn.classList.add('is-busy');
      if (err) err.hidden = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (err) { err.textContent = res.description || res.message || 'No se pudo agregar'; err.hidden = false; }
            setTimeout(function () { if (err) err.hidden = true; }, 6000);
            return;
          }
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = {
            resource: {},
            sourceId: String(data.get('id')),
            data: {
              source: 'product-form-component',
              itemCount: Number(data.get('quantity')) || 1,
              productId: form.dataset.productId,
              sections: res.sections
            }
          };
          form.dispatchEvent(ev);
          btn.textContent = '✓';
          setTimeout(function () { btn.textContent = '+'; }, 1600);
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.classList.remove('is-busy'); });
    });
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-rail]').forEach(initRail);
    s.querySelectorAll('[data-lm-tabs]').forEach(initTabs);
    s.querySelectorAll('[data-marquee]').forEach(initMarquee);
    s.querySelectorAll('form[data-lm-add]').forEach(initAdd);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
